export enum HandlerTypes {
  HOTELBEDS = 'HotelBeds',
  TRAVELPORT = 'TravelPort',
  MYSTIFLY = 'Mystifly',
  PRICELINE = 'PriceLine'
}
